import axios from 'axios';
const appConfigJson = require('@src/app.config')


class AppConfig{

  config = null;

  async loadAppConfigAsync() {
    if (this.config == null) {
      var configResponse = await axios.get('/admin/' + "config.json", "application/json").then(r => r.data);
      this.config = configResponse;
    }
    return this.config;
  }

}

export default new AppConfig();